export const productLoading = "product/loading";
export const productError = "product/Error";
export const productGet = "product/Get";
export const getSingle = "product/getSingle";
